import React, { useContext } from 'react'
import { Button } from '@fs/zion-ui'
import { useGroupData, useImageOrganizeModes } from '../../hooks'
import { OverlayContext } from '../../../../../shared/providers/overlayContextProvider/OverlayContext'
import transl from './GroupDataHeader.transl'

export default function ViewAnotherButton() {
  const { viewAnotherItemOverlay } = useContext(OverlayContext)

  const { isDivideMode } = useImageOrganizeModes()
  const { itemCount } = useGroupData()
  const isDividedGroup = itemCount > 1

  return (
    <>
      {(isDividedGroup || isDivideMode) && (
        <Button emphasis="low" color="blue" onClick={viewAnotherItemOverlay.open}>
          {transl.selectItem()}
        </Button>
      )}
    </>
  )
}
